import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';


OverflowTooltip.propTypes = {
  value: PropTypes.any,
  sx: PropTypes.object
};

export default function OverflowTooltip({ value, sx, ...other }) {
  const textElementRef = useRef();
  const [hoverStatus, setHover] = useState(false);

  const compareSize = () => {
    const isOverflowing =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setHover(isOverflowing);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener('resize', compareSize);

    // Cleanup function to remove event listener on unmount
    return () => {
      window.removeEventListener('resize', compareSize);
    };
  }, []);

  const formattedValue = (
    <>
      <Stack direction="column" spacing={1}>
        <Typography variant="caption" sx={{ fontWeight: 600 }}>{value}</Typography>
        { other?.secondValue && <span style={{ fontSize: 12 }}>{other.secondValue}</span> }
      </Stack>
    </>
  )

  return (
    <Tooltip
      title={formattedValue}
      // interactive
      placement="top"
      disableHoverListener={!hoverStatus}
      sx={{ fontSize: '2em' }}
    >
      <Typography 
          variant="subtitle3" 
          noWrap 
          ref={textElementRef}
          sx={{ overflow: "hidden", textOverflow: "ellipsis", ...sx }}
        >
        { value }
        { other?.secondValue && 
          <span style={{ fontSize: 12 }}>
            <br/>{other.secondValue}
          </span> 
        }
      </Typography>
    </Tooltip>
  );
};